import React, { useMemo, useState } from "react";
import { Button } from "@smiles/voebiz-ui-kit";
import { MdBusinessCenter, MdPinDrop, MdPerson } from "react-icons/md";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useUser } from "../../hooks/useUser";

import { UpdateModal, CollapsedContent } from "../../components";

import { formatCEP, formatCNPJ, formatCpfOnString, phoneValidation } from "../../utils/documentUtils";
import { hasEditUserTicket } from "../../utils/ticketUtils";

export default function Profile() {
  const { state, isLoading } = useUser();
  const [openModal, setOpenModal] = useState(false);
  const toggle = () => setOpenModal(!openModal);
  const { apiDomain } = useFlags();

  const editDisabled = useMemo(() => {
    if (state?.member && state?.member.status === "ACTIVE") {
      return hasEditUserTicket(state?.zendesk, apiDomain);
    }
    return true;
  }, [state.zendesk]);

  if (isLoading) {
    return <div />;
  }

  const mainActivityValue = state.dropdowns.mainActivity?.items.find(
    (item) => state.member.mainActivity === item.id && item,
  );
  const occupationValue = state.dropdowns.occupation?.items.find((item) => state.member.occupation === item.id && item);

  return (
    <div className="vbz-lf">
      <div className="vbz-profile-content">
        <div className="vbz-profile-content-container">
          <p className="vbz-profile-content-container--text">
            {editDisabled
              ? "As novas informações serão validadas. Até lá, você verá os dados informados anteriormente."
              : "Aqui estão todos os dados do seu cadastro no VoeBiz. Você pode atualizá-los sempre que necessário."}
          </p>
          <Button
            className="vbz-profile-content-container--button"
            type="pill"
            fill
            onClick={toggle}
            disabled={editDisabled}
          >
            {editDisabled ? "Solicitação de dados em análise" : "Solicitar atualização dos dados"}
          </Button>
        </div>
        <div className="vbz-profile-content-container">
          <CollapsedContent
            isDisabled={editDisabled}
            header={{ fieldName: "Dados da empresa", icon: <MdBusinessCenter size={24} /> }}
            contents={[
              {
                name: "CNPJ",
                value: formatCNPJ(state.member.CNPJ),
              },
              {
                name: "Número de funcionários",
                value: state.member.numberOfEmployees,
              },
              {
                name: "Razão social",
                value: state.member.socialReason,
              },
              {
                name: "Atividade principal",
                value: mainActivityValue?.description,
              },
              {
                name: "Nome fantasia",
                value: state.member.fantasyName,
              },
              {
                name: "Orçamento para viagens",
                value: state.member.annualBudgetforTravel,
              },
            ]}
          />
          <CollapsedContent
            isDisabled={editDisabled}
            header={{ fieldName: "Endereço", icon: <MdPinDrop size={24} /> }}
            contents={[
              {
                name: "CEP",
                value: formatCEP(state.member.address.zipCode),
              },
              {
                name: "Endereço",
                value: state.member.address.streetAddress,
              },
              {
                name: "Estado",
                value: state.member.address.state,
              },
              {
                name: "Número",
                value: state.member.address.streetAddressNumber,
              },
              {
                name: "Cidade",
                value: state.member.address.city,
              },
              {
                name: "Complemento",
                value: state.member.address.complement,
              },
            ]}
          />
          <CollapsedContent
            isDisabled={editDisabled}
            header={{ fieldName: "Administrador da conta", icon: <MdPerson size={24} /> }}
            contents={[
              {
                name: "CPF",
                value: formatCpfOnString(state.member.DOcumentNumber),
              },
              {
                name: "Telefone 1",
                value: `+55 ${phoneValidation(state.member.celPhoneDDDNumber1, state.member.celPhoneNumber1)}`,
              },
              {
                name: "Nome completo",
                value: `${state.member.firstName} ${state.member.lastName}`,
              },
              {
                name: "Telefone 2",
                value: `+55 ${phoneValidation(state.member.homePhoneDDDNumber1, state.member.homePhoneNumber1)}`,
              },
              {
                name: "Área de atuação",
                value: occupationValue?.description,
              },
              {
                name: "E-mail",
                value: state.member.email,
              },
            ]}
          />
        </div>
      </div>
      <UpdateModal isOpen={openModal} toggle={toggle} state={state} />
    </div>
  );
}
